<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import dragula from '@/vendor/dragula.js'
import { useLogger } from '@booksy-com/vue-tools'

/*
 * Usage:
 *
 * <draggable :options="options" @drag="dragCallback">
 *   <div v-for="(item, index) in items" data-dragula-index="index">...</div>
 * </draggable>
 *
 */
const DEFAULT_OPTIONS = {
  direction: 'vertical',
}

const DRAKE_EVENTS = [
  'drag',
  'dragend',
  'drop',
  'cancel',
  'remove',
  'shadow',
  'over',
  'out',
  'cloned',
]

export default {

  emits: [
    'drake-created',
    'drop-with-indices',
  ],
  name: 'b-draggable',

  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },

  setup () {
    const logger = useLogger('b-draggable')

    return {
      logger,
    }
  },

  data () {
    return {
      drake: null,
    }
  },

  methods: {

    bind: function () {
      const options = Object.assign({}, DEFAULT_OPTIONS, this.options)
      this.logger.debug('bind', options)

      this.drake = dragula([this.$el], options)

      this.$emit('drake-created', this.drake)

      DRAKE_EVENTS.forEach(event => {
        this.drake.on(event, (...args) => {
          // Emit event for parent components
          this.$emit(event, ...args)

          // Handle drop event internally
          if (event === 'drop') {
            this.onDrop(...args)
          }
        })
      })
    },

    destroy: function () {
      this.logger.debug('destroy')
      this.drake.destroy()
      this.drake = null
    },

    onDrop (el, target, source, sibling) {
      const oldIndex = parseInt(el.dataset.dragulaIndex)
      const newIndex = Array.prototype.indexOf.call(el.parentNode.children, el)
      this.$emit('drop-with-indices', oldIndex, newIndex)
    },

    // call this method to fix order based on data-dragula-index
    fixOrder: function () {
      const parent = this.$el
      Array.prototype.slice.call(parent.children)
        // remove children from DOM
        .map(function (el) { return parent.removeChild(el) })
        // sort children by dragula index
        .sort(function (a, b) {
          return parseInt(a.dataset.dragulaIndex)
          - parseInt(b.dataset.dragulaIndex)
        })
        // reattach childern to DOM
        .forEach(function (el) { parent.appendChild(el) })
    },

    grab (e) {
      this.drake.grab(e)
    },
  },

  created: function () {
    this.logger.debug('created')
  },

  mounted: function () {
    this.logger.debug('mounted')
    this.bind()
  },

  unmounted: function () {
    this.logger.debug('destroyed')
    this.destroy()
  },
}
</script>
